  import { createTheme } from '@mui/material/styles';

  export const THEME = createTheme({
    typography: {
      fontFamily: `"Montserrat"`,
      semibold: 600,
    },
    palette: {
      primary: {
        main: "#662D91", // Cor principal
        light: "#75429C", // Versão mais clara
        dark: "#5C2882", // Versão mais escura
        contrastText: "#ffffff", // Cor do texto em botões etc.
      },
      secondary: {
        main: "#ffca55", // Cor principal
        light: "#F7A941", // Versão mais clara
        dark: "#F8B254", // Versão mais escura
        contrastText: "#3A2307", // Cor do texto em botões etc.
      },
      tertiary: {
        main: "#666666", // Cor principal
        light: "#C0BAC8", // Versão mais clara
        dark: "#5c5c5c", // Versão mais escura
        contrastText: "#662D91", // Cor do texto em botões etc.
      },
      quaternary: {
        main: "#fafafa", // Cor principal
        light: "#ffff", // Versão mais clara
        dark: "#f4f4f4", // Versão mais escura
        contrastText: "#662D91", // Cor do texto em botões etc.
      },
    },

    components: {
      MuiAlert: {
        styleOverrides: {
          root: {
            borderRadius: 8,
          },
          outlinedInfo: {
            borderColor: "#662D91",
            backgroundColor: "#d1cfea6c",
            color: "#662D91",

            // 👇 muda a cor do ícone:
            "& .MuiAlert-icon": {
              color: "#662D91",
            },

            // 👇 muda o texto da mensagem:
            "& .MuiAlert-message": {
              color: "#662D91",

              fontSize: "14px",
            },
          },
        },
      },
      MuiTextField: {
        styleOverrides: {
          root: {
            "& .MuiOutlinedInput-root": {
              "&:hover fieldset": {
                borderColor: "#662d91",
              },
              "&.Mui-focused fieldset": {
                borderColor: "#522474",
              },
            },
          },
        },
      },
      MuiInputLabel: {
        styleOverrides: {
          root: {
            color: "var(--secondaryColor)", // Cor padrão
            "&.Mui-focused": {
              color: "#662d91", // Cor quando focado
            },
          },
        },
      },
      MuiAppBar: {
        styleOverrides: {
          colorPrimary: {
            color: "#4C535F",
          },
        },
      },
      MuiSnackbarContent: {
        styleOverrides: {
          root: {
            backgroundColor: "#fafafa", // Cor personalizada
            color: "#4C535F", // Cor do texto
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          outlined: {
            borderWidth: "2px",
            borderStyle: "solid",
            borderColor: "currentColor", // Usa a cor herdada do tema
            "&:hover": {
              borderWidth: "2px", // Consistente no hover
            },
          },
        },
      },
    },
  });